// extracted by mini-css-extract-plugin
export default {"goal-items":"Goal_goal-items__lhmFR","goal-items__title":"Goal_goal-items__title__OsYTl","goal-items__category":"Goal_goal-items__category__aQwbb"};